/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Health_RegistryInputs */

const en_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health / Registry`)
};

const es_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salud / Registro`)
};

const fr_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Santé / Enregistrement`)
};

const de_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheit / Register`)
};

const ja_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健康状態 / 登録証明`)
};

const zh_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健康 / 注册信息`)
};

const ar_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصحة / السجل`)
};

const id_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesehatan / Registrasi`)
};

const it_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salute / Pedigree`)
};

const ru_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здоровье / Регистрация`)
};

const pt_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde / Registro`)
};

const ko_field_health_registry = /** @type {(inputs: Field_Health_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`건강 상태 / 혈통 등록`)
};

/**
* | output |
* | --- |
* | "Health / Registry" |
*
* @param {Field_Health_RegistryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_health_registry = /** @type {((inputs?: Field_Health_RegistryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Health_RegistryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_health_registry(inputs)
	if (locale === "es") return es_field_health_registry(inputs)
	if (locale === "fr") return fr_field_health_registry(inputs)
	if (locale === "de") return de_field_health_registry(inputs)
	if (locale === "ja") return ja_field_health_registry(inputs)
	if (locale === "zh") return zh_field_health_registry(inputs)
	if (locale === "ar") return ar_field_health_registry(inputs)
	if (locale === "id") return id_field_health_registry(inputs)
	if (locale === "it") return it_field_health_registry(inputs)
	if (locale === "ru") return ru_field_health_registry(inputs)
	if (locale === "pt") return pt_field_health_registry(inputs)
	return ko_field_health_registry(inputs)
});